import React, { Component } from 'react';
import { I18n } from 'react-i18next';
import Menu from './menu';
import Footer from './footer';
import { API_PATH } from '../helper/constants';

const VALIDATION_KEYS = {
    EMAIL_REQUIRED: 'contact_error.email_required',
    EMAIL_INVALID: 'contact_error.email_invalid',
    TITLE_REQUIRED: 'contact_error.title_required',
    CONTENT_REQUIRED: 'contact_error.content_required',
    CONTENT_TOO_LONG: 'contact_error.content_too_long',
    FAILED_TO_SUBMIT: 'contact_failed'
};

class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            title: '',
            content: '',
            loading: false,
            errors: {},
            submitSuccess: false
        };
    }

    componentDidMount() {
        setTimeout(() => this.node.scrollIntoView(), 0);
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;
        const finalValue = name === 'content' ? value.slice(0, 1000) : value;
        
        this.setState({
            [name]: finalValue,
            errors: {
                ...this.state.errors,
                [name]: ''
            }
        });
    }

    validateForm = () => {
        const { email, title, content } = this.state;
        const errors = {};

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email.trim()) {
            errors.email = VALIDATION_KEYS.EMAIL_REQUIRED;
        } else if (!emailRegex.test(email)) {
            errors.email = VALIDATION_KEYS.EMAIL_INVALID;
        }

        // Title validation
        if (!title.trim()) {
            errors.title = VALIDATION_KEYS.TITLE_REQUIRED;
        }

        // Content validation
        if (!content.trim()) {
            errors.content = VALIDATION_KEYS.CONTENT_REQUIRED;
        } else if (content.length > 1000) {
            errors.content = VALIDATION_KEYS.CONTENT_TOO_LONG;
        }

        this.setState({ errors });
        return Object.keys(errors).length === 0;
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        if (!this.validateForm()) {
            return;
        }

        this.setState({ loading: true });

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/${API_PATH.CONTACT}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: this.state.email,
                    title: this.state.title,
                    content: this.state.content
                })
            });

            if (!response.ok) {
                throw new Error('Failed to submit form');
            }

            this.setState({
                email: '',
                title: '',
                content: '',
                submitSuccess: true
            });

            // Reset success message after 3 seconds
            setTimeout(() => {
                this.setState({ submitSuccess: false });
            }, 3000);

        } catch (error) {
            console.error('Error submitting form:', error);
            this.setState({
                errors: {
                    submit: VALIDATION_KEYS.FAILED_TO_SUBMIT
                }
            });
        } finally {
            this.setState({ loading: false });
        }
    }

    render() {
        const { email, title, content, errors, loading, submitSuccess } = this.state;

        return (
            <I18n ns="translations">
                {
                    (t) => (
                        <div id="wraper-other" ref={node => this.node = node}>
                            <header>
                                <Menu currentItem="contact"/>
                            </header>
                            <div id="contact">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-12 col-md-12 service-top">
                                            <h2 className="text-center wow bounce">{t('contact_1')}</h2>
                                            <div className="form-contact wow rotateIn">
                                                {submitSuccess && (
                                                    <div className="alert alert-success">
                                                        {t('contact_success')}
                                                    </div>
                                                )}
                                                {errors.submit && (
                                                    <div className="alert alert-danger">
                                                        {t(errors.submit)}
                                                    </div>
                                                )}
                                                <form onSubmit={this.handleSubmit}>
                                                    <div className="form-group">
                                                        <label htmlFor="email">{t('contact_2')}</label>
                                                        <input
                                                            type="email"
                                                            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                                            id="email"
                                                            name="email"
                                                            value={email}
                                                            onChange={this.handleInputChange}
                                                        />
                                                        {errors.email && (
                                                            <div className="invalid-feedback text-danger">{t(errors.email)}</div>
                                                        )}
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="title">{t('contact_3')}</label>
                                                        <input
                                                            type="text"
                                                            className={`form-control ${errors.title ? 'is-invalid' : ''}`}
                                                            id="title"
                                                            name="title"
                                                            value={title}
                                                            onChange={this.handleInputChange}
                                                        />
                                                        {errors.title && (
                                                            <div className="invalid-feedback text-danger">{t(errors.title)}</div>
                                                        )}
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="content">{t('contact_4')}</label>
                                                        <textarea
                                                            className={`form-control ${errors.content ? 'is-invalid' : ''}`}
                                                            id="content"
                                                            name="content"
                                                            rows="5"
                                                            value={content}
                                                            onChange={this.handleInputChange}
                                                        />
                                                        {errors.content && (
                                                            <div className="invalid-feedback text-danger">{t(errors.content)}</div>
                                                        )}
                                                        <small className="text-muted">
                                                            {t('contact_4_limit', { 
                                                                current: content.length, 
                                                                max: 1000 
                                                            })}
                                                        </small>
                                                    </div>
                                                    <p className="text-center wow shake" data-wow-delay="1s">
                                                        <button
                                                            type="submit"
                                                            className="btn"
                                                            disabled={loading}
                                                        >
                                                            {loading ? t('contact_submitting') : t('contact_5')}
                                                        </button>
                                                    </p>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Footer/>
                        </div>
                    )
                }
            </I18n>
        );
    }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/containers/contact.jsx